module.exports = __webpack_public_path__ + "img/addMember.fb1e80b2.svg";